import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import "../geometry.js";
import r from "../request.js";
import t from "../core/Error.js";
import { HandleOwnerMixin as s } from "../core/HandleOwner.js";
import { isSome as i } from "../core/maybe.js";
import { MultiOriginJSONMixin as o } from "../core/MultiOriginJSONSupport.js";
import { throwIfAbortError as a } from "../core/promiseUtils.js";
import { urlToObject as l, objectToQuery as n, makeAbsolute as p } from "../core/urlUtils.js";
import { property as c } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { cast as u } from "../core/accessorSupport/decorators/cast.js";
import { reader as m } from "../core/accessorSupport/decorators/reader.js";
import { subclass as h } from "../core/accessorSupport/decorators/subclass.js";
import { writer as d } from "../core/accessorSupport/decorators/writer.js";
import y from "./Layer.js";
import { APIKeyMixin as f } from "./mixins/APIKeyMixin.js";
import { ArcGISCachedService as v } from "./mixins/ArcGISCachedService.js";
import { ArcGISMapService as g } from "./mixins/ArcGISMapService.js";
import { ArcGISService as S } from "./mixins/ArcGISService.js";
import { BlendLayer as _ } from "./mixins/BlendLayer.js";
import { CustomParametersMixin as j } from "./mixins/CustomParametersMixin.js";
import { OperationalLayer as b } from "./mixins/OperationalLayer.js";
import { PortalLayer as T } from "./mixins/PortalLayer.js";
import { RefreshableLayer as w } from "./mixins/RefreshableLayer.js";
import { ScaleRangeLayer as O } from "./mixins/ScaleRangeLayer.js";
import { SublayersOwner as L } from "./mixins/SublayersOwner.js";
import { parse as R, isHostedAgolService as x, isArcGISUrl as U } from "./support/arcgisLayerUrl.js";
import { url as P } from "./support/commonProperties.js";
import A from "./support/Sublayer.js";
import W from "../geometry/SpatialReference.js";
var I = ["Canvas/World_Dark_Gray_Base", "Canvas/World_Dark_Gray_Reference", "Canvas/World_Light_Gray_Base", "Canvas/World_Light_Gray_Reference", "Elevation/World_Hillshade", "Elevation/World_Hillshade_Dark", "Ocean/World_Ocean_Base", "Ocean/World_Ocean_Reference", "Ocean_Basemap", "Reference/World_Boundaries_and_Places", "Reference/World_Boundaries_and_Places_Alternate", "Reference/World_Transportation", "World_Imagery", "World_Street_Map", "World_Topo_Map"];

var M = /*#__PURE__*/function (_ref) {
  _inherits(M, _ref);

  var _super = _createSuper(M);

  function M() {
    var _this;

    _classCallCheck(this, M);

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(e)), _this.listMode = "show", _this.isReference = null, _this.operationalLayerType = "ArcGISTiledMapServiceLayer", _this.resampling = !0, _this.sourceJSON = null, _this.spatialReference = null, _this.path = null, _this.sublayers = null, _this.type = "tile", _this.url = null;
    return _this;
  }

  _createClass(M, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e, r) {
      return "string" == typeof e ? _objectSpread({
        url: e
      }, r) : e;
    }
  }, {
    key: "load",
    value: function load(e) {
      var _this2 = this;

      var r = i(e) ? e.signal : null;
      return this.addResolvingPromise(this.loadFromPortal({
        supportedTypes: ["Map Service"]
      }, e).catch(a).then(function () {
        return _this2._fetchService(r);
      })), Promise.resolve(this);
    }
  }, {
    key: "attributionDataUrl",
    get: function get() {
      var e;
      var r = null == (e = this.parsedUrl) ? void 0 : e.path.toLowerCase();
      return r && this._getDefaultAttribution(this._getMapName(r));
    }
  }, {
    key: "readSpatialReference",
    value: function readSpatialReference(e, r) {
      return (e = e || r.tileInfo && r.tileInfo.spatialReference) && W.fromJSON(e);
    }
  }, {
    key: "writeSublayers",
    value: function writeSublayers(e, r, t, s) {
      if (!this.loaded || !e) return;

      var i = e.slice().reverse().flatten(function (_ref2) {
        var e = _ref2.sublayers;
        return e && e.toArray().reverse();
      }).toArray(),
          o = [],
          a = _objectSpread({
        writeSublayerStructure: !1
      }, s);

      i.forEach(function (e) {
        var r = e.write({}, a);
        o.push(r);
      });
      o.some(function (e) {
        return Object.keys(e).length > 1;
      }) && (r.layers = o);
    }
  }, {
    key: "tileServers",
    get: function get() {
      return this._getDefaultTileServers(this.parsedUrl.path);
    }
  }, {
    key: "castTileServers",
    value: function castTileServers(e) {
      return Array.isArray(e) ? e.map(function (e) {
        return l(e).path;
      }) : null;
    }
  }, {
    key: "fetchTile",
    value: function fetchTile(e, t, s) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var o = i.signal,
          a = this.getTileUrl(e, t, s),
          l = {
        responseType: "image",
        signal: o,
        query: _objectSpread({}, this.refreshParameters)
      };
      return r(a, l).then(function (e) {
        return e.data;
      });
    }
  }, {
    key: "getTileUrl",
    value: function getTileUrl(e, r, t) {
      var s = !this.tilemapCache && this.supportsBlankTile,
          i = n(_objectSpread(_objectSpread(_objectSpread({}, this.parsedUrl.query), {}, {
        blankTile: !s && null
      }, this.customParameters), {}, {
        token: this.apiKey
      })),
          o = this.tileServers;
      return "".concat(o && o.length ? o[r % o.length] : this.parsedUrl.path, "/tile/").concat(e, "/").concat(r, "/").concat(t).concat(i ? "?" + i : "");
    }
  }, {
    key: "_fetchService",
    value: function _fetchService(e) {
      var _this3 = this;

      return new Promise(function (s, o) {
        if (_this3.sourceJSON) {
          if (null != _this3.sourceJSON.bandCount && null != _this3.sourceJSON.pixelSizeX) throw new t("tile-layer:unsupported-url", "use ImageryTileLayer to open a tiled image service");
          return void s({
            data: _this3.sourceJSON
          });
        }

        if (!_this3.parsedUrl) throw new t("tile-layer:undefined-url", "layer's url is not defined");
        var a = R(_this3.parsedUrl.path);
        if (i(a) && "ImageServer" === a.serverType) throw new t("tile-layer:unsupported-url", "use ImageryTileLayer to open a tiled image service");
        r(_this3.parsedUrl.path, {
          query: _objectSpread(_objectSpread(_objectSpread({
            f: "json"
          }, _this3.parsedUrl.query), _this3.customParameters), {}, {
            token: _this3.apiKey
          }),
          responseType: "json",
          signal: e
        }).then(s, o);
      }).then(function (r) {
        if (r.ssl && (_this3.url = _this3.url.replace(/^http:/i, "https:")), _this3.sourceJSON = r.data, _this3.read(r.data, {
          origin: "service",
          url: _this3.parsedUrl
        }), 10.1 === _this3.version && !x(_this3.url)) return _this3._fetchServerVersion(_this3.url, e).then(function (e) {
          _this3.read({
            currentVersion: e
          });
        }).catch(function () {});
      });
    }
  }, {
    key: "_fetchServerVersion",
    value: function _fetchServerVersion(e, s) {
      if (!U(e)) return Promise.reject();
      var i = e.replace(/(.*\/rest)\/.*/i, "$1") + "/info";
      return r(i, {
        query: _objectSpread(_objectSpread({
          f: "json"
        }, this.customParameters), {}, {
          token: this.apiKey
        }),
        responseType: "json",
        signal: s
      }).then(function (e) {
        if (e.data && e.data.currentVersion) return e.data.currentVersion;
        throw new t("tile-layer:version-not-available");
      });
    }
  }, {
    key: "_getMapName",
    value: function _getMapName(e) {
      var r = e.match(/^(?:https?:)?\/\/(server\.arcgisonline\.com|services\.arcgisonline\.com|ibasemaps-api\.arcgis\.com)\/arcgis\/rest\/services\/([^\/]+(\/[^\/]+)*)\/mapserver/i);
      return r && r[2];
    }
  }, {
    key: "_getDefaultAttribution",
    value: function _getDefaultAttribution(e) {
      if (!e) return;
      var r;
      e = e.toLowerCase();

      for (var _t = 0, _s = I.length; _t < _s; _t++) {
        if (r = I[_t], r.toLowerCase().indexOf(e) > -1) return p("//static.arcgis.com/attribution/" + r);
      }
    }
  }, {
    key: "_getDefaultTileServers",
    value: function _getDefaultTileServers(e) {
      var r = -1 !== e.search(/^(?:https?:)?\/\/server\.arcgisonline\.com/i),
          t = -1 !== e.search(/^(?:https?:)?\/\/services\.arcgisonline\.com/i);
      return r || t ? [e, e.replace(r ? /server\.arcgisonline/i : /services\.arcgisonline/i, r ? "services.arcgisonline" : "server.arcgisonline")] : [];
    }
  }, {
    key: "hasOverriddenFetchTile",
    get: function get() {
      return !this.fetchTile.__isDefault__;
    }
  }]);

  return M;
}(_(L(O(b(T(v(g(S(o(s(w(f(j(y))))))))))))));

e([c({
  readOnly: !0
})], M.prototype, "attributionDataUrl", null), e([c({
  type: ["show", "hide", "hide-children"]
})], M.prototype, "listMode", void 0), e([c({
  type: Boolean,
  json: {
    read: !1,
    write: {
      enabled: !0,
      overridePolicy: function overridePolicy() {
        return {
          enabled: !1
        };
      }
    }
  }
})], M.prototype, "isReference", void 0), e([c({
  readOnly: !0,
  type: ["ArcGISTiledMapServiceLayer"]
})], M.prototype, "operationalLayerType", void 0), e([c({
  type: Boolean
})], M.prototype, "resampling", void 0), e([c()], M.prototype, "sourceJSON", void 0), e([c({
  type: W
})], M.prototype, "spatialReference", void 0), e([m("spatialReference", ["spatialReference", "tileInfo"])], M.prototype, "readSpatialReference", null), e([c({
  type: String,
  json: {
    origins: {
      "web-scene": {
        read: !0,
        write: !0
      }
    },
    read: !1
  }
})], M.prototype, "path", void 0), e([c({
  readOnly: !0
})], M.prototype, "sublayers", void 0), e([d("sublayers", {
  layers: {
    type: [A]
  }
})], M.prototype, "writeSublayers", null), e([c({
  json: {
    read: !1,
    write: !1
  }
})], M.prototype, "popupEnabled", void 0), e([c()], M.prototype, "tileServers", null), e([u("tileServers")], M.prototype, "castTileServers", null), e([c({
  readOnly: !0,
  json: {
    read: !1
  }
})], M.prototype, "type", void 0), e([c(P)], M.prototype, "url", void 0), M = e([h("esri.layers.TileLayer")], M), M.prototype.fetchTile.__isDefault__ = !0;
var C = M;
export { C as default };